module.exports = __webpack_public_path__ + "static/img/0012.2c83ca1c.png";